// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1N3c1","question":"Question_question__1emxc","description":"Question_description__3LLCo"};